import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';
import { toggleModal } from '../reducers/generalReducer.js';
import { fetchTeamEvents } from './calendarThunks.js';
import { canCreateEventByDateRange } from './helper.js';

export const fetchSickLeaves = createAsyncThunk('sickLeave/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const data = await API.sickLeaves.getAll();
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const createSickLeave = createAsyncThunk('sickLeave/create', async ({ data }, { dispatch, rejectWithValue }) => {
    try {
        await canCreateEventByDateRange(data.startDate, data.endDate);
        await API.sickLeaves.create(data);

        notification.info({ message: 'Success', description: 'Sick leave was created' });
        dispatch(fetchTeamEvents());
        dispatch(toggleModal({ modal: 'sickLeave', isOpen: false }));

        return true;
    } catch (error) {
        notification.error({ message: 'ERROR', description: error.message });
        return rejectWithValue(error.message);
    }
});

export const updateSickLeave = createAsyncThunk(
    'sickLeave/update',
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            await canCreateEventByDateRange(data.startDate, data.endDate, id);
            await API.sickLeaves.update(data, id);

            notification.info({ message: 'Success', description: 'Sick leave was updated' });
            dispatch(fetchTeamEvents());
            dispatch(toggleModal({ modal: 'sickLeaveEdit', isOpen: false }));
            dispatch(toggleModal({ modal: 'eventView', isOpen: false }));

            return true;
        } catch (error) {
            notification.error({ message: 'ERROR', description: error.message });
            return rejectWithValue(error.message);
        }
    },
);

export const deleteSickLeave = createAsyncThunk('sickLeave/delete', async ({ id }, { dispatch, rejectWithValue }) => {
    try {
        await API.sickLeaves.delete(id);

        notification.info({ message: 'Success', description: 'Sick leave was deleted' });
        dispatch(fetchTeamEvents());
        dispatch(toggleModal({ modal: 'sickLeaveEdit', isOpen: false }));
        dispatch(toggleModal({ modal: 'eventView', isOpen: false }));

        return true;
    } catch (error) {
        notification.error({ message: 'ERROR', description: error.message });
        return rejectWithValue(error.message);
    }
});
